import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { maximumEndcNrCellChartConfig } from '../cellChartConfigs';

/**
 * Props for the MaximumEndcNrCell component
 */
interface MaximumEndcNrCellProps {
  /** Name of the NR cell */
  cellName: string;
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Maximum ENDC Sessions Chart (NR Cell Level)
 * 
 * Displays EN-DC session capacity metrics for individual NR cells:
 * - Maximum ENDC Users (count)
 * 
 * @component
 * @see {@link ../cellChartConfigs.ts} - Chart configuration (maximumEndcNrCellChartConfig)
 * @see API: /api/nr/cell/maximum-endc?cell_name={cellName}
 */
const MaximumEndcNrCell: React.FC<MaximumEndcNrCellProps> = ({ 
  cellName, 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  // Memoize additionalParams to prevent infinite re-renders
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);

  return (
    <SiteCharts 
      config={maximumEndcNrCellChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
      additionalParams={additionalParams}
    />
  );
};

export default MaximumEndcNrCell;
